import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import axios from 'axios';

interface FileDetail {
  name: string;
  url: string;
}

export default function UploadsGrid() {
  const [files, setFiles] = useState<FileDetail[]>([]);
  const backendUrl = 'https://rednext31.ddns.net:3005'; // Asegúrate de que este es el puerto correcto de tu backend

  useEffect(() => {
    const fetchFiles = async () => {
      try {
        const response = await axios.get<FileDetail[]>(`${backendUrl}/api/uploads`);
        const updatedFiles = response.data.map(file => ({
          ...file,
          url: `${backendUrl}${file.url}`
        }));
        setFiles(updatedFiles);
      } catch (error) {
        console.error('Error al obtener los archivos:', error);
      }
    };

    fetchFiles();
  }, []);

  const handleDownload = (url: string, fileName: string) => {
    axios({
      url: url,
      method: 'GET',
      responseType: 'blob',
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    }).catch((error) => {
      console.error('Error al descargar el archivo:', error);
    });
  };

  const isImage = (fileName: string) => {
    return /\.(jpg|jpeg|png|gif)$/i.test(fileName);
  };

  return (
    <Container className="mt-4">
      <Row>
        {files.map((file) => (
          <Col key={file.name} xs={12} sm={6} md={4} lg={3} className="mb-4">
            <Card>
              <Card.Body>
                <Card.Title className="text-truncate">{file.name}</Card.Title>
                {isImage(file.name) ? (
                  <>
                    <Card.Img 
                      variant="top" 
                      src={file.url} 
                      alt={file.name} 
                      style={{ height: '200px', objectFit: 'cover' }}
                    />
                    <Button variant="outline-primary" size="sm" className="mt-2" onClick={() => handleDownload(file.url, file.name)}>Descargar Imagen</Button>
                  </>
                ) : (
                  <Button variant="outline-primary" size="sm"onClick={() => handleDownload(file.url, file.name)}>Descargar Archivo</Button>
                )}
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
      {files.length === 0 && (
        <p className="text-center text-muted">No hay archivos subidos aún.</p>
      )}
    </Container>
  );
}